"use strict";
const initLoadMore = () => {
    const buttons = document.querySelectorAll('.js-load-more');
    buttons.forEach((button) => {
        button.addEventListener('click', async () => {
            const container = button
                .closest('.block-archive')
                ?.querySelector('.js-posts-container');
            if (!container) {
                return;
            }
            const postType = button.dataset.postType ?? 'post';
            const perPage = Number(button.dataset.perPage ?? '3');
            const currentOffset = Number(button.dataset.offset ?? 0);
            button.disabled = true;
            const formData = new FormData();
            formData.append('offset', String(currentOffset));
            formData.append('action', 'load_more_posts');
            formData.append('nonce', var_from_php.nonce);
            formData.append('post_type', postType);
            formData.append('per_page', String(perPage));
            try {
                const response = await fetch(var_from_php.ajax_url, {
                    method: 'POST',
                    body: formData,
                });
                const result = await response.json();
                if (result.success) {
                    console.log(result.data);
                    container.insertAdjacentHTML('beforeend', result.data.html);
                    button.dataset.offset = String(currentOffset + perPage);
                    if (!result.data.has_more) {
                        button.remove();
                    }
                }
            }
            catch (error) {
                console.error(error);
            }
            finally {
                button.disabled = false;
            }
        });
    });
};
document.addEventListener('DOMContentLoaded', initLoadMore);
